<template>
  <v-dialog scrollable v-model="$store.state.confirmMessage.confirmDialog" persistent max-width="480">
    <v-card>
      <v-card-title class="text-center d-flex flex-column">
        <v-icon :color="defineCor">{{icons[type]}}</v-icon>
       <span class="title">{{title}}</span>
      </v-card-title>
      <v-card-text class="text-center" v-html="message"></v-card-text>
      <v-card-text class="text-center" v-if="listaLink.show">
      <list-message :lista="listaLink.lista" />
      </v-card-text>

      <v-form ref="messageTextForm" :value="textFormValid">
        <v-card-text v-if="textForm.show" class="px-12 py-0">
          <legend class="px-12">{{textForm.title? textForm.title: "Justificativa"}}</legend>
          <v-textarea
            class="px-12"
            outlined
            flat
            solo
            dense
            height="150px"
            :rules="formRules.required"
            :placeholder="textForm.label"
            v-model="messageText"
          ></v-textarea>
        </v-card-text>
        <v-card-text v-if="selectMenu.show">
          <label>{{ selectMenu.label }}</label>
          <v-autocomplete
            v-model="selectedItem"
            :value="selectMenu.item"
            :items="selectMenu.items"
            :item-text="item => item.text.length > maxLengthItem ? `${item.id} - ${item.text.slice(0, maxLengthItem)}...` : `${item.id} - ${item.text}` "
            label="Selecione"
            outlined
            flat
            solo
            dense
            filled
            return-object
            clearable
          />
        </v-card-text>
      </v-form>
      <v-card-actions class="pt-0 pb-3">
        <v-spacer></v-spacer>
        <v-btn
          height="32px"
          small
          v-show="btCancel.show"
          color="primary"
          outlined
          @click="doCancel"
        >{{btCancel.name}}</v-btn>
        <v-btn
          v-if="!!btExtra"
          height="32px"
          small
          v-show="btExtra.show"
          :color="btExtra.color ? btExtra.color : 'primary'"
          outlined
          @click="doExtra"
        >{{btExtra.name}}</v-btn>
        <v-btn
          height="32px"
          small
          v-show="btConfirm.show"
          :color="btConfirm.color"
          depressed
          @click="doCallback"
        >{{btConfirm.name}}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import listMessage from "./listMessage.vue";
export default {
  components:{
    listMessage
  },
  props: {
    message: String,
    title: String,
    type: String,
    callback: Function,
    listaLink: Object,
    messageForm: Function,
    btConfirm: Object,
    btCancel: Object,
    btExtra: {
      type: Object,
      default() {
        return {
          show: false,
          name: '',
          callback: null
        }
      }
    },
    textForm: Object,
    selectMenu: Object,
    selectMenuForm: Function,
    maxLengthItem: Number
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
    defineCor() {
    let cor = this.type == 'tutorial'? 'primary' : this.type;
      return cor;
    },
  },
  mounted () {},
  methods: {
    doCallback () {
      this.$store.commit('confirmMessage/closeConfirmMessage')
      if (this.callback) {
        this.callback()
      }
      if (this.messageText) {
        this.messageForm(this.messageText)
        this.messageText = null
        this.textForm.title = null
        this.$refs.messageTextForm.reset()
      }
      if (this.selectedItem) {
        this.selectMenuForm(this.selectedItem)
        this.selectedItem = null
      }
      // if (this.callback && !this.textForm.show) {
      //   this.callback()
      //   this.$store.commit('confirmMessage/closeConfirmMessage')
      // }
      // if (this.messageText == null && this.textForm.show) {
      //   this.$refs.messageTextForm.validate()
      // }
      // if (this.messageText != null && this.textForm.show) {
      //   this.messageForm(this.messageText)
      //   this.messageText = null
      //   this.$refs.messageTextForm.reset()
      //   this.$store.commit('confirmMessage/closeConfirmMessage')
      // }
    },
    doCancel () {
      if(this.btCancel.callback){
        this.btCancel.callback()
      }
      this.$store.commit('confirmMessage/closeConfirmMessage')
      if (this.textForm.show) {
        this.messageText = null
        this.$refs.messageTextForm.reset()
      }
    },
    doExtra () {
      if(this.btExtra.callback){
        this.btExtra.callback()
        if(this.btExtra.noShow){
          return
        }
      }
      this.$store.commit('confirmMessage/closeConfirmMessage')
      if (this.textForm.show) {
        this.messageText = null
        this.$refs.messageTextForm.reset()
      }
    }
  },

  data () {
    return {
      messageText: null,
      textFormValid: true,
      icons: {
        error: 'fa-exclamation-circle',
        warning: 'fa-exclamation-circle',
        info: 'far fa-question-circle',
        success: 'far fa-check-circle',
        tutorial:'fa-regular fa-life-ring'
      },
    }
  },
}
</script>

<style>
.confirmMesgTxt {
  border-bottom: 1px solid #eee;
}
</style>
